import { createGlobalState } from 'react-use';

/**
 * Global state to track whether the user has chosen to complete the survey later.
 * Used to ensure that the survey isn't shown until the app is loaded again.
 */
export default createGlobalState(false);
